import { CheckIcon, ColorSwatch, Flex, Tooltip, UnstyledButton } from '@mantine/core'
import { useTranslation } from 'react-i18next'

/**
 * The palette this run measured, one swatch each.
 *
 * The colours were already reaching the picker, mixed in with the house
 * defaults and behind a click, which is the same as not offering them: the
 * operator had no way to know the run had found anything. This is the row the
 * slogans have had all along, in the form a colour takes — click a swatch to
 * use it, and the one in the field is marked.
 *
 * Renders nothing when the run measured no colours, which is every field
 * before the first generation.
 */
export function ColorSuggestions({ options, value, onSelect }) {
  const { t } = useTranslation()
  if (!options || options.length === 0) return null

  const current = String(value || '').trim().toLowerCase()

  return (
    <Flex wrap="wrap" gap={6} mt={6}>
      {options.map((color) => (
        <Tooltip label={color} withArrow position="top" key={color}>
          <UnstyledButton
            aria-label={t('editorV2.form.common.useColor', { color })}
            aria-pressed={color === current}
            onClick={() => onSelect(color)}
          >
            <ColorSwatch color={color} size={22} withShadow>
              {color === current && <CheckIcon size={10} />}
            </ColorSwatch>
          </UnstyledButton>
        </Tooltip>
      ))}
    </Flex>
  )
}
